module.exports = __webpack_public_path__ + "static/media/mobile-logo.d1104989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-logo.svg
// module id = 3075
// module chunks = 0